import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#BE9E86]" data-id="element-108">
      <HeroSection data-id="element-109" />
      <FeaturesSection data-id="element-110" />
      <Footer data-id="element-111" />
    </main>;
}